import { getAdvancedSearchQueriesInitialState } from '../advanced-search-queries/advanced-search-queries-state.js';
import { makeAnalyticsAction, } from '../analytics/analytics-utils.js';
import { getQueryInitialState } from '../query/query-state.js';
export const logFetchMoreResults = () => makeAnalyticsAction('search/logFetchMoreResults', (client) => client.makeFetchMoreResults());
export const logQueryError = (error) => makeAnalyticsAction('search/queryError', (client, state) => client.makeQueryError({
    query: state.query?.q || getQueryInitialState().q,
    aq: state.advancedSearchQueries?.aq ||
        getAdvancedSearchQueriesInitialState().aq,
    cq: state.advancedSearchQueries?.cq ||
        getAdvancedSearchQueriesInitialState().cq,
    dq: state.advancedSearchQueries?.dq ||
        getAdvancedSearchQueriesInitialState().dq,
    errorType: error.type,
    errorMessage: error.message,
}));
